import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Get today's nutrition data
 * @param {string} accessToken - Access token
 * @returns {Promise<Object>} Today's nutrition
 */
export const getTodayNutrition = async (accessToken) => {
  const response = await apiClient.get('/api/nutrition/today', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

/**
 * Get week's nutrition data
 * @param {string} accessToken - Access token
 * @returns {Promise<Array>} Week's nutrition
 */
export const getWeekNutrition = async (accessToken) => {
  const response = await apiClient.get('/api/nutrition/week', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

/**
 * Get month's nutrition data
 * @param {string} accessToken - Access token
 * @returns {Promise<Array>} Month's nutrition
 */
export const getMonthNutrition = async (accessToken) => {
  const response = await apiClient.get('/api/nutrition/month', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

/**
 * Calculate activity calories
 * @param {string} accessToken - Access token
 * @param {Object} activityData - Activity data (activity_type, duration_minutes, intensity)
 * @returns {Promise<Object>} Calculated calories
 */
export const calculateActivity = async (accessToken, activityData) => {
  const response = await apiClient.post('/api/nutrition/calculate-activity', activityData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};
